import { type ReactNode } from 'react'
import styles from './Table.module.css'

export interface Colonna<T> {
  chiave: string
  intestazione: ReactNode
  render: (riga: T) => ReactNode
  larghezza?: string
  allineamento?: 'left' | 'right' | 'center'
}

interface Props<T> {
  colonne: Colonna<T>[]
  righe: T[]
  vuoto?: ReactNode
  onClickRiga?: (riga: T) => void
}

export function Table<T extends { id?: string }>({ colonne, righe, vuoto, onClickRiga }: Props<T>) {
  if (righe.length === 0 && vuoto) {
    return <div className={styles.vuoto}>{vuoto}</div>
  }

  return (
    <div className={styles.wrapper}>
      <table className={styles.tabella}>
        <thead>
          <tr>
            {colonne.map((c) => (
              <th
                key={c.chiave}
                style={{ width: c.larghezza, textAlign: c.allineamento ?? 'left' }}
              >
                {c.intestazione}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {righe.map((r, i) => (
            <tr
              key={r.id ?? i}
              className={onClickRiga ? styles.cliccabile : undefined}
              onClick={onClickRiga ? () => onClickRiga(r) : undefined}
            >
              {colonne.map((c) => (
                <td key={c.chiave} style={{ textAlign: c.allineamento ?? 'left' }}>
                  {c.render(r)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
